// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"18b8aa8d","136":"a30a9e70","215":"4a27e5cf","274":"47973657","317":"8b7c9cd8","430":"da6bb916","453":"c8baf5ec","462":"ce7aed77","580":"a94fa03d","627":"72428d73","728":"44ca6cf8","748":"4944479a","776":"04112e6b","832":"27131c30","852":"843ee2b8","979":"3b563f23"}[chunkId] + ".chunk.js";
};